import { render, staticRenderFns } from "./EmployeesDetails.vue?vue&type=template&id=2ff385d3&"
import script from "./EmployeesDetails.vue?vue&type=script&lang=js&"
export * from "./EmployeesDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports